import { useEffect, useState } from "react";
import useEcoClient from "../useEcoClient";
import { useDownloadBrowser } from "./useDownloadBrowser";

/**
 * Hooks for download file inside eco-factory
 * This hooks doesn't force the file to be download.
 * Avoid downloading large file using this hooks, this may take all the memory
 */
export const useDownload = () => {

    const ecoClient = useEcoClient();
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [errors, setErrors] = useState<any>()
    const browserDownload = useDownloadBrowser()

    useEffect(() => {
        setIsError(errors !== undefined)
    }, [errors])

    const download = async (docId: number, forceBrowserToDownload?: boolean, fileName?: string) : Promise<Blob | void> => {
        if(docId) {
            try {
                setIsLoading(true)
                const blob = await ecoClient.post<Blob>({
                    path: 'entityDoc.get',
                    data: { 
                        view_tp: 'entity.download',
                        entity: 'Doc',
                        id: docId,
                    },
                    config: { responseType: 'blob' }
                })
        
                if (forceBrowserToDownload) {
                    browserDownload(blob, fileName as string)
                }
        
                return blob
            } catch (e) {
                setErrors(e)
            } finally {
                setIsLoading(false)
            }
        }
    }

    return {
        download,
        isLoading,
        isError,
        errors
    }
}

export default useDownload
